import { AgrLoginTypes } from '@next/core-lib/environment';

import { RoughagePlusEnvironment } from './environment.model';

export { RoughagePlusEnvironment } from './environment.model';

export const environment: RoughagePlusEnvironment = {
  APPLICATION_NAME: 'Roughage Plus App',
  APPLICATION_KEY: 'RoughagePlusApp',
  PRODUCTION: false,
  CLIENT_ID: '82c898ca-bc2d-4ce1-9ce0-c635fd17cbf0',
  AUTHORITY:
    'https://agrifirmb2cdev.b2clogin.com/tfp/agrifirmb2cdev.onmicrosoft.com',
  SIGNUP_SIGNIN_POLICY:
    'B2C_1_AllAccountsSignupSignin' as RoughagePlusEnvironment['SIGNUP_SIGNIN_POLICY'],
  LEAD_SIGNUP_POLICY: 'B2C_1_Lead_Signup',
  EMPLOYEE_SIGNIN_POLICY: 'B2C_1A_EMPLOYEESIGNIN',
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  REDIRECT_URL: 'http://localhost:4200/auth',
  API_BASE_URL: 'http://localhost:4200',
  APP_INSIGHTS_KEY: 'aaac3537-49ba-4259-8e8c-e7716f3902e9',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  MSAL_LOGGING: true,
  ENABLE_SILAGE_SOIL: true,
  ENABLE_SOIL: true,
  ENABLE_TELEMETRY: true,
  DEFAULT_LOCALE: 'nl-NL',
  LOCALES: [],
};
